export const iconFontAwesomeArrowsArrowTurnDown = (
	<i className="fa-solid fa-arrow-turn-down"></i>
);
